import { render, staticRenderFns } from "./projects-item.vue?vue&type=template&id=2691c20e"
import script from "./projects-item.vue?vue&type=script&lang=js"
export * from "./projects-item.vue?vue&type=script&lang=js"
import style0 from "./projects-item.vue?vue&type=style&index=0&id=2691c20e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports